<script>
import Card from "./Card";

export default {
  components: {
    Card
  }
};
</script>

<template>
  <Card
    header="Produtos de limpeza"
    text="Durante o agendamento você pode escolher entre o profissional levar os produtos básicos para a limpeza ou ele utilizar os produtos de sua preferência que você tem disponíveis no local."
    imagePath="/static/dashboard/cleaning-products.svg"
    inverted
  />
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/cards/Products.vue